import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BeneListComponent } from './bene-list/bene-list.component';
import { ProfileLandingComponent } from './profile/profile-landing/profile-landing.component';
import { AddDegreeComponent } from './profile/education/add-degree/add-degree.component';
//import { BeneficiaryImmigrationComponent } from './profile/beneficiary-immigration/beneficiary-immigration.component';
//import { WorkExperienceComponent } from './profile/work-experience/work-experience.component';
import { GenericBeneficiaryImmigrationDetailsLibraryModule } from 'generic-beneficiary-immigration-details-library';
import { GenericBeneficiaryWorkExperienceModule } from 'generic-beneficiary-work-experience';
import { BeneficiaryTrainingComponent } from './profile/beneficiary-training/beneficiary-training.component';
import { BeneficiaryLicenseComponent } from './profile/beneficiary-license/beneficiary-license.component';
import { DirtyFormGuard } from 'src/app/dirty-form.guard';
import {FindPetitionerComponent} from './find-petitioner/find-petitioner.component';
import {UndocumentedBeneficiariesComponent} from './undocumented-beneficiaries/undocumented-beneficiaries.component';
import {DisplayInformationComponent} from './display-information/display-information.component';
import { BeneficiaryInviteComponent } from './beneficiary-invite/beneficiary-invite.component';
import { RequestDataPetitionerDisplayComponent } from './request-data-petitioner-display/request-data-petitioner-display.component';
import { BeneficiaryInformationComponent } from './beneficiary-information/beneficiary-information.component';
import { EmployeeJobDetailsComponent } from './profile/employee-job-details/employee-job-details.component';
import { BeneListGridComponent } from './bene-list-grid/bene-list-grid/bene-list-grid.component';
import { I9EmployeeDetailsComponent } from './i9-employee-details/i9-employee-details.component';
import { BeneficiaryProfileDataComponent } from './beneficiary-profile-data/beneficiary-profile-data.component';
import { EducationDetailsComponent } from './simple-profile/education-details/education-details.component';
import { ExperienceDetailsComponent } from './simple-profile/experience-details/experience-details.component';
import { ImmigrationDetailsComponent } from './simple-profile/immigration-details/immigration-details.component';
import { DocumentsChecklistComponent } from './simple-profile/documents-checklist/documents-checklist.component';
import { BenePersonalDetailsComponent } from './simple-profile/bene-personal-details/bene-personal-details.component';
//import { PersonalDetailsComponent } from './profile/personal-details/personal-details.component';
import { GenericBeneficiaryPersonalDetailsLibraryModule } from 'generic-beneficiary-personal-details-library';
import { OcrConverterComponent } from './profile/ocr-converter/ocr-converter.component';
import { ExpiryAlertDocumentsComponent } from './expiry-alert-documents/expiry-alert-documents.component';

const beneficiaryRoutes: Routes = [
    {
        path: 'list',
        component: BeneListComponent,
        pathMatch: 'full'
    },
    {
        path: 'list-grid',
        component: BeneListGridComponent,
        pathMatch: 'full'
    },
    {
        path: 'beneficiary-invite',
        component: BeneficiaryInviteComponent,
    },
    {
      path: 'beneficiary-profile',
      loadChildren: () => import('../beneficiary-questionnaire/beneficiary-questionnaire.module').then(m => m.BeneficiaryQuestionnaireModule),
    },
    {
        path: 'request-data',
        component: RequestDataPetitionerDisplayComponent,
        pathMatch: 'full'
    },
    {
        path: 'find-petitioner',
        component: FindPetitionerComponent,
        pathMatch: 'full'
    },
    {
        path: 'beneficiary-profile-data',
        component: BeneficiaryProfileDataComponent,
        children: [
            {
                path: 'bene-personal-details',
                component: BenePersonalDetailsComponent,
                canDeactivate: [ DirtyFormGuard ]
            },
            {
                path: 'expiry-alert-documents',
                component: ExpiryAlertDocumentsComponent,
                canDeactivate: [ DirtyFormGuard ]
            },
            {
                path: 'education-details',
                component: EducationDetailsComponent,
                canDeactivate: [ DirtyFormGuard ]
            },
            {
                path: 'experience-details',
                component: ExperienceDetailsComponent,
                canDeactivate: [ DirtyFormGuard ]
            },
            {
                path: 'immigration-details',
                component: ImmigrationDetailsComponent,
                canDeactivate: [ DirtyFormGuard ]
            },
            {
                path: 'documents-checklist',
                component: DocumentsChecklistComponent,
                canDeactivate: [ DirtyFormGuard ]
            },
            {
                path: 'expiry-alert-documents',
                component: ExpiryAlertDocumentsComponent,
                canDeactivate: [ DirtyFormGuard ]
            },
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'bene-personal-details'
            }
        ]
    },
    {
        path: 'profile',
        component: ProfileLandingComponent,
        children: [
            {
                path: 'profile-details',
                component: OcrConverterComponent,
                canDeactivate: [ DirtyFormGuard ]
            },
            {
                path: 'personal',
                loadChildren: () =>
                import('generic-beneficiary-personal-details-library').then(
                  (m) => m.GenericBeneficiaryPersonalDetailsLibraryModule
                ),
                canDeactivate: [DirtyFormGuard]
            },
            {
                path: 'education',
                component: AddDegreeComponent,
                canDeactivate: [ DirtyFormGuard ]
            },
            {
                path: 'immigration',
                loadChildren: () =>
                import('generic-beneficiary-immigration-details-library').then(
                  (m) => m.GenericBeneficiaryImmigrationDetailsLibraryModule
                ),
                canDeactivate: [DirtyFormGuard]
            },
            {
                path: 'training',
                component: BeneficiaryTrainingComponent,
                canDeactivate: [ DirtyFormGuard ]
            },
            {
                path: 'licenses',
                component: BeneficiaryLicenseComponent,
                canDeactivate: [ DirtyFormGuard ]
            },
            {
                path: 'work-experience',
                loadChildren: () =>
                  import('generic-beneficiary-work-experience').then(
                    (m) => m.GenericBeneficiaryWorkExperienceModule
                  ),
                canDeactivate: [DirtyFormGuard]
            },
            {
                path: 'employee-job-deatils',
                component: EmployeeJobDetailsComponent,
                canDeactivate: [ DirtyFormGuard ]
            },
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'profile-details'
            }
        ]
    },
    {
        path: 'alerts',
        loadChildren: () => import('../../modules/alerts/messageAlert.module').then((mod) => mod.MessageAlertModule)
    },
    {
        path: 'undocumented',
        component: UndocumentedBeneficiariesComponent,
        pathMatch: 'full',
    },
    {
        path: 'i9-employee-details',
        component: I9EmployeeDetailsComponent,
        pathMatch: 'full',
    },
    {
        path: 'questionnier',
        component: BeneficiaryInformationComponent,
        children: [
            {
                path: 'education',
                component: AddDegreeComponent,
                canDeactivate: [ DirtyFormGuard ]
            },
            {
                path: 'immigration',
                loadChildren: () =>
                import('generic-beneficiary-immigration-details-library').then(
                  (m) => m.GenericBeneficiaryImmigrationDetailsLibraryModule
                ),
              canDeactivate: [DirtyFormGuard]
            },
            {
                path: 'training',
                component: BeneficiaryTrainingComponent,
                canDeactivate: [ DirtyFormGuard ]
            },
            {
                path: 'licenses',
                component: BeneficiaryLicenseComponent,
                canDeactivate: [ DirtyFormGuard ]
            },
            {
                path: 'work-experience',
                loadChildren: () =>
                  import('generic-beneficiary-work-experience').then(
                    (m) => m.GenericBeneficiaryWorkExperienceModule
                  ),
                canDeactivate: [DirtyFormGuard]
            },
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'education'
            }
        ]
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'list'
    },
    {
        path: "update-employment",
        loadChildren: () =>
          import("./../update-employment/update-employment.module").then(
            (m) => m.UpdateEmploymentModule
          ),
    }
];

@NgModule({
    imports: [RouterModule.forChild(beneficiaryRoutes)],
    exports: [RouterModule],
    providers: []
})
export class BeneficiaryRoutingModule { }
